import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, FooterButton } from 'Core/components';
import CustomPropTypes from 'Core/prop-types';
import { addMold, editMold } from './store/slice';
import { AppModal } from '../components/app-modals';
import { showToast } from 'Core/redux/toast/slice';
import MoldReceivingAddEditForm from './mold-receiving-add-edit-form';
import { useDocumentUpload } from '../../core/hooks';
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner';

// const ignoreKeys = [
//   'additionalComments',
//   'carrier',
//   'changed',
//   'conditionofShipment',
//   'customerIdExt',
//   'customerLocation',
//   'customerName',
//   'customerNumber',
//   'customerShortName',
//   'engineeringApprovedBy',
//   'functionalTestResult',
//   'inspectedBy',
//   'isDeleted',
//   'label',
//   'moldDocuments',
//   'moldHeight',
//   'moldInfoID',
//   'moldLength',
//   'moldWidth',
//   'partID',
//   'prevToolID',
//   'previousToolId',
//   'qualityControlApprovedBy',
//   'status',
//   'submittedBy',
//   'trackingNumber',
//   'unloadingApproval',
//   'visualInspectionDamage',
//   'visualInspectionLabeling',
//   'visualInspectionRust',

// ];
const requiredFields = [
  //'toolID',
  'CustomerId',
  // 'moldNumber',
  'shipmentDate',
  'receivedDate',
];

const MoldReceivingAddEdit = ({ showModal, modalData, onCloseModal }) => {
  const [formData, setFormData] = useState(modalData || null);
  const [tempFiles, setTempFile] = useState([]);
  const { uploadDocuments } = useDocumentUpload();
  const [uploadLoading, setUploadLoading] = useState(false);
  const [formRef, setFormRef] = useState(null);
  const [validated, setValidated] = useState(false);
  const [invalidFields, setInvalidFields] = useState([]);
  const [showValidation, setShowValidation] = useState(false);

  const dispatch = useDispatch();
  const isEditMode = Boolean(formData?.toolID);

  const onFileUpload = (documentName, file) => {
    if (file) {
      setTempFile(prevFiles => {
        const updatedFiles = prevFiles.map(f =>
          f.documentName === documentName ? { ...f, file } : f,
        );

        // If documentName exists, update it; otherwise, add new file
        const isExisting = prevFiles.some(f => f.documentName === documentName);

        return isExisting ? updatedFiles : [...prevFiles, { file, documentName }];
      });
    }
  };

  const getFormRef = ref => {
    setFormRef(ref);
  };

  const onChangesForm = data => {
    console.log('onChangesForm called with data:', data);
    console.log('onChangesForm: CustomerId in data:', data.CustomerId);
    console.log('onChangesForm: MaterialType in data:', data.materialType);
    console.log('onChangesForm: moldDocuments in data:', data.moldDocuments);
    console.log('onChangesForm: Previous formData.CustomerId:', formData?.CustomerId);
    console.log('onChangesForm: Previous formData.materialType:', formData?.materialType);
    console.log('onChangesForm: Previous formData.moldDocuments:', formData?.moldDocuments);
    
    setFormData(data);

    // Check which required fields are missing
    const missingFields = requiredFields.filter(field => {
      return !data[field] || data[field].toString().trim() === '' || data[field] === 0;
    });
    setInvalidFields(missingFields);
    // If all fields are filled, clear validation
    if (missingFields.length === 0) {
      setShowValidation(false);
    }
  };
  const handleClose = () => {
    onCloseModal();
  };

  const body = () => {
    return (
      <MoldReceivingAddEditForm
        data={formData}
        onChanges={onChangesForm}
        onFileUpload={onFileUpload}
        isEditMode={isEditMode}
        formRef={getFormRef}
        invalidFields={invalidFields}
        showValidation={showValidation}
        onLoadingChange={setUploadLoading}
      />
    );
  };

  const validateForm = () => {
    if (!formRef || !formRef.current) {
      console.error('Form reference is not available');
      return false;
    }

    // Add the 'was-validated' class to show validation feedback
    formRef.current.classList.add('was-validated');

    // Check form validity
    const isValid = formRef.current.checkValidity();

    if (!isValid) {
      dispatch(
        showToast({
          message: 'Please fill all required fields',
          type: 'danger',
        }),
      );
    }

    return isValid;
  };

  // const valid = payload => {
  //   console.log(payload) ;
  //   if (
  //       !payload ||
  //       Object.keys(payload).some(key => {
  //         return !ignoreKeys.includes(key) && !payload[key] ;
  //       })
  //     ) {
  //       dispatch(
  //         showToast({
  //           message: 'Please fill all required fields',
  //           type: 'danger',
  //         }),
  //       );
  //       return false;
  //     }
  //     return true;
  //   };

  const valid = payload => {
    const isFieldMissing = field => {
      const value = payload[field];

      if (Array.isArray(value)) {
        return value.length === 0;
      }

      if (value === null || value === undefined) {
        return true;
      }

      if (typeof value === 'number') {
        return value === 0;
      }

      if (typeof value === 'string') {
        return value.trim() === '';
      }

      if (typeof value === 'object') {
        return Object.keys(value).length === 0;
      }

      return false;
    };

    const missingFields = requiredFields.filter(field => isFieldMissing(field));

    setInvalidFields(missingFields);

    if (missingFields.length > 0) {
      dispatch(
        showToast({
          message: `Please fill all required fields: ${missingFields.join(', ')}`,
          type: 'danger',
        }),
      );
       setTimeout(() => {
      if (formRef && formRef.current) {
        formRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }, 100);
      return false;
    }

    return true;
  };

  const footer = () => {
    const onSave = async () => {
      setShowValidation(true);
      if (!valid(formData)) return;
      
      // Files are now uploaded immediately when selected, so we can use the current moldDocuments
      // Filter out any documents that are still pending upload
      console.log('Raw formData.moldDocuments:', formData.moldDocuments);
      
      const validMoldDocuments = (formData.moldDocuments || []).filter(doc => 
        doc.documentPath !== null && !doc.isPendingUpload
      );
      
      console.log('Using pre-uploaded documents:', validMoldDocuments);

      // Update formData with the valid moldDocuments list
      const updatedFormData = {
        ...formData,
        moldDocuments: validMoldDocuments,
      };

      // Filter out imageSegments to prevent validation errors on the backend
      const { imageSegments, ImageSegments, ...filteredFormData } = updatedFormData;
      if (imageSegments || ImageSegments) {
        console.log('Submit button: Stripping imageSegments from payload before API call.', {
          removedImageSegmentsLength: (imageSegments || ImageSegments)?.length || 0,
        });
      }

      if (formData.moldInfoID == 0) {
        dispatch(addMold(filteredFormData));
      } else {
        dispatch(editMold(filteredFormData));
      }
    };

    return (
      <div className="row">
        <div className="col-lg-8"></div>
        <div className="col-lg-4">
          <FooterButton
            cancelText="Cancel"
            saveText="Submit "
            onSave={onSave}
            onCancel={handleClose}
          />
        </div>
      </div>
    );
  };

  return (
    <>
      <Modal
        id="mold-receiving-modal"
        show={showModal}
        size="xl"
        title={isEditMode ? 'Edit Mold Receiving' : 'Add Mold Receiving'}
        body={body}
        footer={footer}
        handleClose={handleClose}
      />
      {uploadLoading && <LoadingSpinner />}
    </>
  );
};

MoldReceivingAddEdit.propTypes = {
  showModal: PropTypes.bool,
  modalData: PropTypes.shape(CustomPropTypes.MoldReceiving),
  onCloseModal: PropTypes.func,
};

export default AppModal(MoldReceivingAddEdit);
